import { defineComponent as _defineComponent } from 'vue'
import { Ref, ref, onMounted, reactive, computed, watch } from 'vue';
import TeamTable from './TeamTable.vue';
import { useLoader } from '@/composables/loader';
import CButton from '@/components/shared/CButton';
import CreateMemberModal from './CreateMemberModal.vue';
import UpdateMemberModal from './UpdateMemberModal.vue';
import ConfirmationModal from '@/components/ConfirmationModal/ConfirmationModal.vue';
import MemberAccessModal from '@/components/Team/MemberAccessModal.vue';
import { getTeamMembers, removeTeamMember } from '@/api/team';
import store from '@/store';
import { EntityType, TeamMember } from '@/api/typings/team';


export default /*#__PURE__*/_defineComponent({
  __name: 'Team',
  emits: ['team-updated'],
  setup(__props, { emit }) {


const { execLoadedFn } = useLoader();
const teamMembers = ref<TeamMember[]>([]);
const showAddMemberModal = ref(false);
const showUpdateMemberModal = ref(false);
const showMemberAccessModal = ref(false);
const selectedElem: Ref<TeamMember | undefined> = ref();
const user = computed(() => store.state.user);
const selectedMember = ref<TeamMember | undefined>(undefined);
const selectedEntityType = ref<EntityType>(EntityType.TEMPLATE);
const searchString = ref('');
const currentPage = ref(1);
const itemsPerPage = 10;
const totalCount = ref(0);

const modalValues = reactive({
    title: 'Delete member',
    description: '',
    actionVerb: 'Delete',
    show: false,
    action: null as (() => Promise<void>) | null
});

const fetchTeamMembers = async () => {
    try {
        const from = (currentPage.value - 1) * itemsPerPage;
        const to = from + itemsPerPage;
        const membersResponse = await getTeamMembers(from, to, searchString.value);
        teamMembers.value = membersResponse.teamMembers;
        totalCount.value = membersResponse.totalCount;
    } catch (error) {
        console.error('Failed to fetch team members', error);
    }
};

const assignMemberHandler = async (member: TeamMember) => {
    execLoadedFn(async () => {
        teamMembers.value.push(member);
        showAddMemberModal.value = false;
        emit('team-updated');
    });
};

const assignMemberPermissionsHandler = async (member: TeamMember) => {
    execLoadedFn(async () => {
        selectedMember.value = member;
        showMemberAccessModal.value = true;
    });
};

const assignMemberEntitiesHandler = async (data: { member: TeamMember; entityType: EntityType }) => {
    execLoadedFn(async () => {
        selectedEntityType.value = data.entityType;
        selectedMember.value = data.member;
        showMemberAccessModal.value = true;
    });
};

const onPermissionsUpdated = async (member: TeamMember) => {
    execLoadedFn(async () => {
        selectedMember.value = member;
        showMemberAccessModal.value = false;
    });
};

const onMemberUpdated = async (updatedMember: TeamMember) => {
    execLoadedFn(async () => {
        // Update the member in the teamMembers array
        if (teamMembers.value && updatedMember) {
            const index = teamMembers.value.findIndex((member) => member.user.Id === updatedMember.user.Id);
            if (index !== -1) {
                teamMembers.value[index] = updatedMember;
            }
        }
        selectedMember.value = updatedMember;
    });
};

const onMemberUpdateHandler = async () => {
    execLoadedFn(async () => {
        showUpdateMemberModal.value = false;
        fetchTeamMembers();
    });
};

const onMemberEditHandler = async (member: TeamMember) => {
    execLoadedFn(async () => {
        selectedMember.value = member;
        showUpdateMemberModal.value = true;
    });
};

const cancelMemberHandler = async () => {
    showAddMemberModal.value = false;
};

const cancelMemberUpdateHandler = async () => {
    showUpdateMemberModal.value = false;
};

const cancelMemberPermissionsHandler = async () => {
    showMemberAccessModal.value = false;
};

const toggleDeleteModal = (elem: TeamMember) => {
    selectedElem.value = elem;
    modalValues.description = `<span>Are you sure you want to delete <strong>${elem.user.Name}</strong> member?</span>`;
    modalValues.show = !modalValues.show;
    modalValues.action = callRemoveTeamMember;
};

const callRemoveTeamMember = async () => {
    try {
        console.log(selectedElem.value?.user.Id);
        await removeTeamMember(selectedElem.value!.user.Id);
        teamMembers.value = teamMembers.value.filter((member) => member.user.Id !== selectedElem.value?.user.Id);
        emit('team-updated');
    } catch (error) {
        console.error('Failed to remove team member', error);
    }
};

const openCreateModal = () => {
    showAddMemberModal.value = true;
};

onMounted(fetchTeamMembers);
watch([searchString, currentPage], () => {
    fetchTeamMembers();
});

return { __sfc: true,emit, execLoadedFn, teamMembers, showAddMemberModal, showUpdateMemberModal, showMemberAccessModal, selectedElem, user, selectedMember, selectedEntityType, searchString, currentPage, itemsPerPage, totalCount, modalValues, fetchTeamMembers, assignMemberHandler, assignMemberPermissionsHandler, assignMemberEntitiesHandler, onPermissionsUpdated, onMemberUpdated, onMemberUpdateHandler, onMemberEditHandler, cancelMemberHandler, cancelMemberUpdateHandler, cancelMemberPermissionsHandler, toggleDeleteModal, callRemoveTeamMember, openCreateModal, TeamTable, CButton, CreateMemberModal, UpdateMemberModal, ConfirmationModal, MemberAccessModal }
}

})